import React from 'react';
import Authentication from '../Authenticate/index';
import { Route } from "react-router-dom";
import { privateRoutesPath } from './index'
import PrivateLayout from '../Components/Layout/PrivateLayout';
import ConfigurationPage from '../Pages/Configuration/index';
import BiztantuDashboard from '../Pages/Dashboard/BiztantuDashboard';
const PrivateRoute = (props) => {

    return (
        <PrivateLayout location={props.location}>
            <Authentication>
                <Route exact path={privateRoutesPath.DASHBOARD} component={BiztantuDashboard} />
                <Route exact path={privateRoutesPath.CONFIGURATION} component={ConfigurationPage} />
             
                {/* <Route exact path = {`${privateRoutesPath?.FIRST_USER_PASSWORD_SETUP}`} component = {FisrtUserPasswordSetup} /> */}
            </Authentication>
        </PrivateLayout>
    )
}

export default PrivateRoute;